require('./share.js');
// var login =require('./login.js');
var form = require('./form.js');
// var Modal = require('@pangu/modal');
// var modal = new Modal('.js-modal');
var res = $.extend({}, response);
var Slide = require('./slide.js');
var videoPlayer = require('./videoPlayer.js');
var $video = $('.js-jnh-video');

videoPlayer.init($video, $video.data('src'), $video.data('poster'));

// 报名
// $('.js-open-apply').click(function () {
//     if (!res.logined) {
//         login.open();
//         return;
//     }

//     if (!form.applyed) {
//         form.reset();
//     }
//     modal.open();
// });

// 底部切换
new Slide($('.js-gallery').children(), {
    duration: 2500
});

// 直播
// var $player = $('.js-live-player');
// var $tabs = $('.js-live-tab a');
// var players = {
//     cc: { type: 'flash', data: 'http://res.cc.netease.com/webcc/weblbs/htdocs/webcc/stoneSwf/ClientLoader.swf?roomId=1314&subId=3478054&ch_type=ty&useBlank=1&play_mode=1&config=List&showGetInRoomLayer=1&useChat=1&showChat=0&joinRoomConnetServer=1&webccType=4082&updateBarrage=1&playerParam=nomask,1;src,ty' },
//     douyu: { type: 'embed', data: '<embed width="100%" height="100%" allownetworking="all" allowscriptaccess="always" src="https://staticlive.douyucdn.cn/common/share/play.swf?room_id=2314536" quality="high" bgcolor="#000" wmode="window" allowfullscreen="true" allowFullScreenInteractive="true" type="application/x-shockwave-flash">' },
//     panda: { type: 'flash', data: 'http://s6.pdim.gs/static/84b032315f9e6373.swf?videoId=ffd3d345f7d7a4f4957eb8c63442727c&roomId=1148171' },
//     bilibili: { type: 'flash', data: 'http://static.hdslb.com/live-static/swf/LivePlayerEx_1.swf?_=1-1-c5a315d&cid=941004&rnd=1497595869&type=1&onready=flash_on_ready_callback&initTime=1497595779068&changeMode=false' }
// };

// $tabs.click(function () {
//     var index = $tabs.index(this);
//     var name = $(this).data('name');
//     var player = players[name];

//     $tabs.removeClass('active').eq(index).addClass('active');

//     switch (player.type) {
//     case 'flash':
//         $player.flash({
//             swf: player.data,
//             height: "100%",
//             width: "100%",
//             allowFullScreen: true,
//             wmode: 'opaque',
//             allowScriptAccess:'always',
//             base:'.',
//             quality:"high" ,
//             bgcolor:"#ffffff"
//         });
//         break;
//     default:
//         $player.html(player.data);
//         break;
//     }
// });

// $tabs.eq(0).click();



//////////////////
// WEBPACK FOOTER
// ./pages/anniversary/js/jnh.js
// module id = 0
// module chunks = 2